module.exports = __webpack_public_path__ + "img/login_bg.2f62dbba.jpg";